import { FC } from 'react'
import styles from 'components/features/pfm/ColoredText/ColoredText.styl'

type ColoredTextProps = {
  color: 'success' | 'coral'
}

export const ColoredText: FC<ColoredTextProps> = (props) => {
  const { color, children } = props

  return (
    <span className={ styles[color] }>{ children }</span>
  )
}
